"use client";

import { Divider } from "@dafiti/closet-ui";
import { usePathname } from "next/navigation";

import { useCatalogResults } from "../../../hooks/useCatalogResults.hook";
import { useFiltersQuery } from "../../../hooks/useFiltersQuery.hook";
import type { CatalogMetaResponse } from "../../../types/catalog.type";
import { getCatalogTitle } from "../../../types/catalogTitle.helper";
import { AppliedFiltersDesktop } from "../../Filters/AppliedFiltersDesktop";
import { QuickFiltersBar } from "../CatalogFilterBar";
import { CatalogTitle } from "./CatalogTitle";
import { CatalogTotalProducts } from "./CatalogTotalProducts";

type Props = {
  meta: CatalogMetaResponse;
  hideTitle?: boolean;
};

export function CatalogHeader({ meta, hideTitle }: Props) {
  const pathname = usePathname();
  const { facets } = useFiltersQuery();
  const { title } = getCatalogTitle(pathname, meta, facets);
  const { totalProducts, isLoading } = useCatalogResults();

  return (
    <div
      id="catalog-header"
      className="mb-6 mt-1 lg:mt-2 flex flex-col gap-4 scroll-mt-28 lg:scroll-mt-40"
    >
      {!hideTitle ? (
        <div className="order-2 lg:order-1 mt-3xs lg:mt-0">
          <CatalogTitle title={title} />
          <CatalogTotalProducts total={totalProducts} isLoading={isLoading} />
        </div>
      ) : null}

      {!hideTitle ? (
        <Divider className="order-3 lg:order-2 bg-gray-200 hidden lg:block" />
      ) : null}

      {hideTitle ? (
        <div className="order-2 lg:order-1">
          <CatalogTotalProducts total={totalProducts} isLoading={isLoading} />
        </div>
      ) : null}

      <div className="order-1 lg:order-3">
        <QuickFiltersBar meta={meta} />
      </div>

      <div className="lg:order-4">
        <AppliedFiltersDesktop />
      </div>
    </div>
  );
}
